import useSWR from "swr";
import { ago, fetcher, fmt, signed } from "@/lib/api";

const GRADE = { A: "bg-[rgba(14,203,129,0.12)] text-[#0ecb81]", B: "bg-[rgba(252,213,53,0.12)] text-[#fcd535]", C: "bg-[rgba(246,70,93,0.12)] text-[#f6465d]", "—": "bg-[#2b3139] text-[#5e6673]" };

export function StrategyScoreboard() {
  const { data } = useSWR("/strategies/scoreboard", fetcher, { refreshInterval: 30000 });
  if (!data) return <div className="p-3 text-xs text-[#5e6673]">Loading scoreboard…</div>;
  return (
    <div className="overflow-x-auto" data-testid="strategy-scoreboard">
      <div className="px-2 pt-2 text-[10px] text-[#5e6673]">Live {data.label} scorecard per strategy · grade A = 10+ trades, profitable, PF ≥ 1.5 · CUSTOM = promoted walk-forward parameters</div>
      <table className="grid">
        <thead><tr><th>Strategy</th><th>Grade</th><th>Params</th><th className="num">Closed</th><th className="num">Open</th><th className="num">Win %</th><th className="num">Net P&L</th><th className="num">PF</th><th className="num">Expectancy</th><th className="num">Max DD</th><th className="num">Signals</th><th className="num">Executed</th><th className="num">Risk-rej.</th><th>Last trade</th></tr></thead>
        <tbody>
          {data.strategies.map((s) => (
            <tr key={s.name} data-testid={`scoreboard-row-${s.name}`}>
              <td className="text-white font-semibold">{s.label}{s.is_custom && <span className="pill ml-1 bg-[rgba(252,213,53,0.12)] text-[#fcd535]">CUSTOM</span>}</td>
              <td><span className={`pill ${GRADE[s.grade]}`} data-testid={`scoreboard-grade-${s.name}`}>{s.grade}</span></td>
              <td className="mono text-[10px] text-[#848e9c]">{Object.entries(s.active_params).map(([k, v]) => `${k}=${v}`).join(" ")}</td>
              <td className="num">{s.closed_trades}</td><td className="num">{s.open_trades}</td>
              <td className="num">{s.win_rate_pct == null ? "—" : `${fmt(s.win_rate_pct, 1)}%`}</td>
              <td className={`num ${s.net_pnl > 0 ? "up" : s.net_pnl < 0 ? "down" : ""}`}>{s.closed_trades ? signed(s.net_pnl) : "—"}</td>
              <td className="num">{s.profit_factor == null ? "—" : fmt(s.profit_factor)}</td>
              <td className="num">{s.expectancy == null ? "—" : signed(s.expectancy, 3)}</td>
              <td className="num down">{s.closed_trades ? fmt(s.max_drawdown) : "—"}</td>
              <td className="num">{s.signals_generated}</td><td className="num up">{s.signals_executed}</td><td className="num text-[#f6465d]">{s.signals_rejected_risk}</td>
              <td className="text-[#5e6673] mono">{s.last_trade_at ? ago(s.last_trade_at) : "—"}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {data.ai_aggregate_trades > 0 && <div className="px-2 py-1 text-[10px] text-[#5e6673]">{data.ai_aggregate_trades} trade(s) came from the AI aggregate without a single dominant strategy.</div>}
    </div>
  );
}
